export const HEADER_FAIRE_TIMEZONE = "X-FAIRE-TIMEZONE";
